<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'
import VersionBanner from '@/components/common/VersionBanner.vue'
import { ref, onMounted } from 'vue'
import { useVersionCheck } from '@/core/composables/useVersionCheck'

const isReady = ref(false)
const showVersionBanner = ref(true)

// Version checking
const { hasNewVersion, reloadPage } = useVersionCheck()

function handleReload() {
  reloadPage()
}

function dismissBanner() {
  showVersionBanner.value = false
}

onMounted(() => {
  isReady.value = true
})
</script>

<template>
  <RouterView v-if="isReady" v-slot="{ Component }">
    <template v-if="$route.meta.public">
      <Component :is="Component" />
    </template>
    <AppLayout v-else>
      <Component :is="Component" />
    </AppLayout>
  </RouterView>

  <!-- Version update banner -->
  <VersionBanner
    :show="hasNewVersion && showVersionBanner"
    @reload="handleReload"
    @dismiss="dismissBanner"
  />
</template>
